import { render, staticRenderFns } from "./YA_HomeContent.vue?vue&type=template&id=0bb4aa3d&scoped=true"
import script from "./YA_HomeContent.vue?vue&type=script&lang=js"
export * from "./YA_HomeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb4aa3d",
  null
  
)

export default component.exports